export default "__VITE_ASSET__BRtUzl_1__"